const en = {
    contactUs: {
      waitingForContactingUs: "We look forward to your communication with us",
      location: "Location",
      siteLocation: "Al Faisal Tower, Al Wehda St, Doha, Qatar",
      email: "Email",
      phone: "Phone",
      phoneHome: "Home phone number"
    },
    common : {
        usernameAndPasswordRequired: "Please fill username and password!",
        invalidUsernameOrPassword: "Invalid username or password!",
        warning: "Warning",
        error: "Error",
        somethingWentWrong: "Something went wrong, please try again later",
        ConfirmedPassdontMatch: "New Password & Confirmed Password don't match",
        PasswordStrength: "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character",
    }
  };
  
  export default en;
  